import interfaceClass from './Interface.js'
import config from './config.js'

class centralControl {
  centralControl(str, fun, data) {
    var obj = this.getData();
    interfaceClass[str](config.getStr("url")+config.getStr(str), fun, {...data, ...obj.currency},obj.all);
  }

  //拼接需要得参数信息
  getData() {
    const loginInfo = localStorage.getItem("loginInfo");
    const currentLoginInfo = loginInfo ? JSON.parse(loginInfo) : {};
    var obj = {
      // 通用数据
      "currency":{
        userId: currentLoginInfo.id, //登录用户id
        unitCode: currentLoginInfo.unitCode, //上级单位编号
        hospitalCode: currentLoginInfo.hospitalCode, //医院编号编号
        identity:currentLoginInfo.identity,// 登录人身份标识
        token:currentLoginInfo.token,// 登录人token(经销商)
      },
      // 所有配置
      "all":currentLoginInfo
    }
    return obj;
  }
}

let centralcontrol = new centralControl();
export default centralcontrol
